import i18n from '@/i18n'

export const ORTHOPHOTO_CHUNK_SIZE = 5 * 1024 * 1024

const uploadControllers = new Map()

export const registerUploadController = (uploadId, controller) => {
  uploadControllers.set(uploadId, controller)
}

export const clearUploadController = (uploadId, controller) => {
  if (!controller || uploadControllers.get(uploadId) === controller) {
    uploadControllers.delete(uploadId)
  }
}

export const abortUploadRequest = (uploadId) => {
  const controller = uploadControllers.get(uploadId)
  if (!controller) return

  controller.abort()
  uploadControllers.delete(uploadId)
}

export const uploadOrthophotoChunk = async ({ token, partNumber, chunk, signal }) => {
  const uploadUrl = process.env.VUE_APP_API_ORTHOPHOTO_UPLOAD_URL
  if (!uploadUrl) {
    throw new Error(i18n.t('master.orthophoto.upload.messages.urlNotConfigured'))
  }

  const url = new URL(uploadUrl)
  url.searchParams.set('token', token)
  url.searchParams.set('part_number', String(partNumber))

  let response
  try {
    response = await fetch(url, {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      body: chunk,
      signal,
    })
  } catch (error) {
    if (error.name !== 'AbortError') error.isTransientUploadError = true
    throw error
  }

  let payload
  try {
    payload = await response.json()
  } catch {
    const error = new Error(i18n.t('global.fileUploader.messages.uploadInterrupted'))
    error.isFatalUploadError = true
    throw error
  }

  if (!response.ok || payload?.status === false) {
    const error = new Error(i18n.t('global.fileUploader.messages.uploadInterrupted'))
    error.isFatalUploadError = true
    throw error
  }

  const etag = payload.etag || payload.e_tag
  if (!etag) {
    const error = new Error(i18n.t('global.fileUploader.messages.uploadInterrupted'))
    error.isFatalUploadError = true
    throw error
  }

  return String(etag).replaceAll('"', '')
}
